const PRESERVE_EXPLORER_SELECTION_ATTRIBUTE = 'data-keep-selection'

const PRESERVE_EXPLORER_SELECTION_SELECTOR = `[${PRESERVE_EXPLORER_SELECTION_ATTRIBUTE}]`

export const shouldPreserveExplorerSelection = (target: EventTarget | null) => {
  const element =
    target instanceof Element
      ? target
      : target instanceof Node
        ? target.parentElement
        : null

  return !!element?.closest(PRESERVE_EXPLORER_SELECTION_SELECTOR)
}
